module.exports = __webpack_public_path__ + "static/media/5.46f2df72.jpg";